/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef, useMemo, useCallback} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import axios from 'axios'
import Pagination from '../../component/Pagination'
import CustomUseEffect from '../../component/CustomUseEffect'
import {getCity, getPlantV2, getProvince, getSalesAreaLetter} from '../../../../api/modules/getdatalist'
import swal from 'sweetalert'
import CurrencyInput from 'react-currency-input-field'
import {Spinner} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {exportSupplyPoint, fetchConfigDate, fetchSupplyPoint, headers, syncSupplyPoint} from '../../../../services/fetcher'
import {objToParams} from '../../../../utils/objToParams'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetMasterSupplyPoint,
  setIsFetchData,
  setMasterSupplyPoint,
} from '../../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../../hooks/useRowTable'
import * as TableUI from '../../../../components/Table/Table'
import {RowHead} from './RowHead'
import {StyledCard} from '../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import { MultiSelect } from 'react-multi-select-component'
import { PopoverText } from 'src/components'
import { HakAkses } from 'src/components/mikro/getHakAkses'
import Select from 'react-select'
import {
  create as createData, show as showData, update as updateData, remove as removeData
} from "../../../../api/modules/master-data/supply-point"

type Props = {
  className: string
}

const Table: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterSupplyPoint} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [fullSales, setFullSales] = useState<any[]>([])
  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullCity, setFullCity] = useState<any[]>([])

  const [sales, setSales] = useState<any>('')
  const [plant, setPlant] = useState<any>('')
  const [province, setProvince] = useState<any>('')
  const [city, setCity] = useState<any>('')
  const [shadowCity, setShadowCity] = useState<Record<string, number>>({})
  const [active, setActive] = useState('')
  const [tempID, setTempID] = useState(0)
  const [allDate, setAllDate] = useState<any[]>([])
  const [showAdd, setShowAdd] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [isError, setisError] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)

  const clearForm = () => {
    setSales('')
    setPlant('')
    setCity('')
    setActive('')
  }

  useEffect(() => {
    if (showAdd == false) clearForm()
  }, [showAdd])

  useEffect(() => {
    if (showEdit == false) clearForm()
  }, [showEdit])

  const handleCreate = async () => {
    setBtnLoading(true)

    const payload = {
      lang: i18next.language,
      sales_org_code: sales,
      plant_code: plant,
      scnd_sales_group_id: city,
      province_id: province,
      city_id: shadowCity[plant],
      is_active: active ? (active == 'true') : '',
      credentials: localStorage.getItem('credential'),
    }
    await createData(payload)
      .then((res: any) => {
        swal({
          title: `${t('data-added-successfully')}`,
          icon: 'success',
        }).then(() => {
          onFetchData()
          setShowAdd(false)
        })
      })
      .catch((error: any) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleEdit = async () => {
    setBtnLoading(true)
    const payload = {
      lang: i18next.language,
      sales_org_code: sales,
      plant_code: plant,
      scnd_sales_group_id: city,
      province_id: province,
      city_id: shadowCity[plant],
      is_active: active == 'true',
      credentials: localStorage.getItem('credential'),
    }

    await updateData(tempID.toString(), payload)
      .then((res: any) => {
        swal({
          title: `${t('data-updated-successfully')}`,
          icon: 'success',
        }).then(() => {
          setActived(!actived)
          setShowEdit(false)
          onFetchData()
        })
      })
      .catch((error: any) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const dropLetter = async () => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        await removeData(tempID.toString())
          .then((res: any) => {
            swal({
              title: t('data-deleted-successfully'),
              icon: 'success',
            })
            setShowDelete(false)
            setActived(!actived)
            onFetchData()
          })
          .catch(function (error: any) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const rowNumber = useMemo(() => {
    const per = filterSupplyPoint?.per_page ?? 5
    return page * per - per
  }, [filterSupplyPoint?.per_page, page])

  const onReloadTable = () => {
    onFetchData()
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 9,
    onReloadTable,
  })

  const paginateNumber = async (url: string) => {
    try {
      setLoading(true)

      const token = localStorage.getItem('token')
      const credentials = localStorage.getItem('credential')
      const endpoint = `${url}&credentials=${credentials}&${objToParams(filterSupplyPoint)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setAllDate(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setisError(true)
    } finally {
      setLoading(false)
      dispatch(setIsFetchData(false))
    }
  }

  const onFetchData = useCallback(() => {
    setLoading(true)
    setisError(false)
    fetchSupplyPoint(filterSupplyPoint)
      .then((res: any) => {
        setAllDate(res.data.data.data)
        setPage(res.data.data.current_page)
        setPer(res.data.data.per_page)
        setNumberURL(res.data.data.links)
      })
      .catch((err: any) => setisError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterSupplyPoint])

  const getAllSales = async () => {
    await getSalesAreaLetter().then((res) => {
      setFullSales(res.data.data.map((item: any) => {
        return {label: item.name, value: item.code}
      }))
    })
  }
  const getAllPlants = async () => {
    await getPlantV2(sales, '').then((res) => {
      setFullPlant(res.data.data.map((item: any) => {
        return {label: [item?.plant, item?.plant_name].filter((x) => x).join(" - "), value: item?.plant}
      }))

      let shadow: Record<string, number> = {}
      res.data.data.forEach((item: any) => {
        shadow[item?.plant] = parseInt(item?.city_code)
      })
      setShadowCity(shadow)
    })
  }
  const getAllProvinces = async () => {
    await getProvince().then((res) => {
      setFullProvince(res.data.data.map((item: any) => {
        return {label: item.value, value: item.id}
      }))
    })
  }
  const getAllCities = async () => {
    await getCity(province).then((res) => {
      setFullCity(res.data.data.map((item: any) => {
        return {label: item.value, value: item.id}
      }))
    })
  }

  useEffect(() => {
    // getAllDate()
    getAllSales()
    getAllProvinces()
  }, [])

  const [actived, setActived] = useState(false)

  useEffect(() => {
    const getData = setTimeout(onFetchData, 1000)
    return () => clearTimeout(getData)
  }, [onFetchData])

  const handleEditModal = (data: any) => {
    setShowEdit(true)
    setTempID(data?.id)
    setSales(data?.sales_org_code)
    setPlant(data?.plant_code)
    setProvince(data?.secound_sales_group?.region_id)
    setCity(data?.secound_sales_group?.id)
    setActive(String(data?.status == 1))
  }

  CustomUseEffect(() => {
    getAllCities()
  }, [province])

  CustomUseEffect(() => {
    getAllPlants()
  }, [sales])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setMasterSupplyPoint({...filterSupplyPoint, per_page: value ?? 5}))
  }

  const [loadingSync, setLoadingSync] = useState(false)

  const syncTable = async () => {
    setLoadingSync(true)
    try{
      await syncSupplyPoint();
      setLoadingSync(false)
      swal({
        title: `${t('Harga Berhasil Diperbarui')}`,
        icon: 'success',
      }).then(() => {
        onReloadTable();
      })
    }catch(err: any){
      setLoadingSync(false)
      swal({
        title: `${t('failed')}`,
        icon: 'error',
      })
    }
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-sp-filter') as string)
      return persisted
    }catch(e){ return null }
  }

  const handleResetFilter = () => {
    dispatch(resetMasterSupplyPoint())
  }

  const handleExportData = async () => {
    if(loadingExport) return
    try {
      setLoadingExport(true)

      const response = await exportSupplyPoint(filterSupplyPoint);

      const href = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `supply-point.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingExport(false)
    } catch (error) {
      setLoadingExport(false)
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
    }
  }

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <>
            <SelectPageSize
              initialValue={filterSupplyPoint?.per_page ?? 5}
              onChange={(value: any) => handlePageSizeChange(value?.value)}
            />
            { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
          </>
        }
        rightContent={<>
          <button disabled={loadingExport} onClick={handleExportData} className='btn btn-warning d-flex align-items-center'>
            {
              loadingExport ? <i className='fa fa-spinner fa-spin'></i> : <>
                <i className='fa fa-download'></i>
                <p>Export Data</p>
              </>
            }
          </button>
          { hakAkses?.create && (
            <button onClick={() => setShowAdd(true)} className='btn btn-primary d-flex align-items-center'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              <p>{t('order-tambah')}</p>
            </button>
          )}
          <button
            className='btn btn-sm btn-primary'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='/hover'
            title={t('Syncronize')}
            onClick={() => syncTable()}
            disabled={loadingSync}
          >
            <i className={"fas fa-sync-alt " + (loadingSync ? "fa-spin" : "")}></i>
          </button>
        </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : allDate.length === 0 ? (
              <RowEmptyData />
            ) : (
              allDate.map((data: any, _index: number) => (
                <tr key={data?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>
                    <PopoverText
                      content={
                        data?.sales_org?.name
                      }
                      index={rowNumber}
                      trigger='click'
                      className='desc-slicee'
                    />
                  </td>
                  <td>
                    {data?.province?.region_name}
                  </td>
                  <td>
                    {data?.city?.city_name}
                  </td>
                  <td>
                    {data?.plant?.plant}
                  </td>
                  <td>
                    {data?.plant?.name1}
                  </td>
                  <td>
                    {data?.secound_sales_group?.city_name}
                  </td>
                  <td>
                    <span className='d-block '>
                      {data.status != 1 ? (
                        <span className='badge badge-light-danger'>{t('Non-Active')}</span>
                      ) : (
                        <span className='badge badge-light-success'>{t('Active')}</span>
                      )}
                    </span>
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        handleEditModal(data)
                      }}
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('ubah')}
                    >
                      <KTSVG path='/media/icons/duotune/pencil-fill.svg' className='svg-icon-3' />
                    </button>
                  </td>
                    {/* 
                    <button
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('Hapus')}
                      onClick={() => {
                        setTempID(data.id)
                        setShowDelete(true)
                      }}
                    >
                      <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
                    </button>
                  </td> */}
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showAdd}
        onHide={() => setShowAdd(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('order-tambah')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Sales Org</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullSales}
                  onChange={(e: any) => setSales(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('sub-order-gudang')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullPlant}
                  defaultValue={plant}
                  onChange={(e: any) => setPlant(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sales Office')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullProvince}
                  onChange={(e: any) => setProvince(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sales Group')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullCity}
                  onChange={(e: any) => setCity(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>Status</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Select
                    size='sm'
                    aria-label='Default select example'
                    onChange={(e: any) => setActive(e.target.value)}
                  >
                    <option value='' selected>{t('Pilih Status')}</option>
                    <option value='true'> {t('Active')}</option>
                    <option value='false'>{t('Inactive')}</option>
                  </Form.Select>
                </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleCreate()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <>{t('order-tambah')}</>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Edit')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Sales Org</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullSales}
                  value={fullSales.find((item: any) => item.value == sales)}
                  onChange={(e: any) => setSales(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('sub-order-gudang')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullPlant}
                  value={fullPlant.find((item: any) => item.value == plant)}
                  onChange={(e: any) => setPlant(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sales Office')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullProvince}
                  value={fullProvince.find((item: any) => item.value == province)}
                  onChange={(e: any) => setProvince(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Sales Group')}</Form.Label>
            </Col>
            <Col sm={9}>
                <Select
                  id='produsen'
                  placeholder={t('pilih')}
                  options={fullCity}
                  value={fullCity.find((item: any) => item.value == city)}
                  onChange={(e: any) => setCity(e?.value)}
                />
            </Col>
          </Row>
          <Row className='mb-5'>
                <Col sm={3}>
                  <Form.Label>Status</Form.Label>
                </Col>
                <Col sm={9}>
                  <Form.Select
                    size='sm'
                    aria-label='Default select example'
                    onChange={(e: any) => setActive(e.target.value)}
                  >
                    {active == 'true' ? (
                      <>
                        <option selected value='true'>
                          {t('Active')}
                        </option>
                        <option value='false'>{t('Inactive')}</option>
                      </>
                    ) : (
                      <>
                        <option value='true'>{t('Active')}</option>
                        <option selected value='false'>
                          {t('Inactive')}
                        </option>
                      </>
                    )}
                  </Form.Select>
                </Col>
          </Row>
              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={() => handleEdit()} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    <>{t('Edit')}</>
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Hapus')} {t('Konfigurasi Tanggal')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button variant='secondary me-2' onClick={() => setShowDelete(false)}>
              {t('cancel')}
            </Button>
            <Button variant='danger' onClick={() => dropLetter()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {Table}
